import { DateTransform } from '@/shared/utilities/class-validator-extends';
import { Transform, Type } from 'class-transformer';
import { IsArray, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import type { Attachment } from './attachment';
import { MessageContentType } from './message-content-type';

export class PinnedMessage {
  @IsUUID()
  messageId: string;

  @IsUUID()
  conversationId: string;

  @IsUUID()
  senderId: string;

  @IsString()
  bucketId: string;

  @IsString()
  content: string;

  @IsString()
  contentType: MessageContentType;

  @Transform(DateTransform.toClass, { toClassOnly: true })
  @Transform(DateTransform.toPlain, { toPlainOnly: true })
  @Type(() => String)
  sentAt: Dayjs;

  @Transform(DateTransform.toClass, { toClassOnly: true })
  @Transform(DateTransform.toPlain, { toPlainOnly: true })
  @Type(() => String)
  pinnedAt: Dayjs;

  @IsUUID()
  pinnedBy: string;

  @IsOptional()
  @IsString()
  pinReason: string | null;

  @IsObject()
  reactions: Record<string, any>;

  @IsOptional()
  @IsString()
  senderName: string | null;

  @IsOptional()
  @IsString()
  pinnedByName: string | null;

  @IsOptional()
  @IsArray()
  structuredAttachments: Nullable<Attachment[]>;

  constructor(data: Partial<PinnedMessage> = {}) {
    this.messageId = data.messageId || '';
    this.conversationId = data.conversationId || '';
    this.senderId = data.senderId || '';
    this.bucketId = data.bucketId || '';
    this.content = data.content || '';
    this.contentType = data.contentType || MessageContentType.TEXT;
    this.sentAt = data.sentAt || dayjs();
    this.pinnedAt = data.pinnedAt || dayjs();
    this.pinnedBy = data.pinnedBy || '';
    this.pinReason = data.pinReason || null;
    this.reactions = data.reactions || {};
    this.senderName = data.senderName || null;
    this.pinnedByName = data.pinnedByName || null;
    this.structuredAttachments = data.structuredAttachments || null;
  }
}

export interface MessagePinnedRes {
  pinnedMessages: PinnedMessage[];
  totalCount: number;
  nextPageToken: string | null;
  hasMore: boolean;
}
